import React, { useState, useEffect } from 'react';
import "../../templates/Templates.css";
import "../../templates/tables/Table.css";
import "../ComponentsGlobalStyle.css";
import IntradayRecordsRow from './IntradayRecordsRow';
import chevron from '../../img/icons/chevron.png';
import doubleChevron from '../../img/icons/double-chevron.png';
import { formatAccordingToType } from '../../templates/Types'; 
import * as con from '../../GlobalConstants'; 
import {StaticSingleCell } from '../../templates/tables/Cells'     

const calculateFontSize = (width, height) => {
    if (width <= 320) {
        return '10px';
    } else if (width <= 480) {
        return '11px';
    } else if (width <= 768) {
        return '13px';
    } else if (width <= 1024) {
        return '16px';
    } else if (width <= 1480) {
        return '18px';  
    } else {
        return '20px'; 
    }
};

const calculateRecordsPerPage = (width) => {
    if (width <= 480) {
        return 30; 
    } else if (width <= 768) {
        return 32;  
    } else if (width <= 1480) {
        return 32;  
    } else {
        return 32;  
    }
};

const formatDateResponsive = (dateString, width) => {
    return dateString;
};

function IntradayRecordsTable({ fixedSize, data }) {
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(16); 
    const [fontSize, setFontSize] = useState('16px');
    const [paddingCell, setPaddingCell] = useState('5px 10px');
    const [minWidthDate, setMinWidthDate] = useState('250px'); 
    const [minWidthOther, setMinWidthOther] = useState('80px'); 
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const adjustStylesBasedOnResolution = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        
        setScreenWidth(width);

        const newFontSize = calculateFontSize(width, height);
        setFontSize(newFontSize);

        if (width <= 320) {
            setPaddingCell('2px 3px');  
            setMinWidthDate('80px');  
            setMinWidthOther('35px');  
        } else if (width <= 480) {
            setPaddingCell('3px 4px');  
            setMinWidthDate('100px');  
            setMinWidthOther('45px');  
        } else if (width <= 768) {
            setPaddingCell('4px 6px');  
            setMinWidthDate('130px');  
            setMinWidthOther('55px');  
        } else if (width <= 1024) {
            setPaddingCell('5px 7px');  
            setMinWidthDate('150px');  
            setMinWidthOther('65px');  
        } else if (width <= 1480 && height <= 720) {
            setPaddingCell('5px 8px');  
            setMinWidthDate('200px');  
            setMinWidthOther('60px');  
        } else {
            setPaddingCell('5px 10px');  
            setMinWidthDate('250px');  
            setMinWidthOther('80px'); 
        }

        const newRecordsPerPage = calculateRecordsPerPage(width);
        setRecordsPerPage(newRecordsPerPage);
    };

    useEffect(() => {
        adjustStylesBasedOnResolution();  
        window.addEventListener('resize', adjustStylesBasedOnResolution);  

        return () => {
            window.removeEventListener('resize', adjustStylesBasedOnResolution);
        };
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [data]);

    if (!data || data.dates.length === 0) {
        return <div>No hay datos disponibles</div>;
    }

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = data.dates.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(data.dates.length / recordsPerPage);

    const handleFirstPage = () => setCurrentPage(1);
    const handlePreviousPage = () => setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
    const handleNextPage = () => setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
    const handleLastPage = () => setCurrentPage(totalPages);


    const paginationTextStyle = {
        margin: screenWidth <= 480 ? '0 6px' : '0 10px',
        color: 'white', 
        lineHeight: '16px', 
        marginTop: '-4px',
        fontSize: screenWidth <= 320 ? '11px' : 'inherit'
    };

    const paginationText = screenWidth <= 480 
        ? `${currentPage}/${totalPages}` 
        : `Página ${currentPage} de ${totalPages}`;

    return (
        <div 
         style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        }}>
            <div 
                className="pagination" 
                style={{ 
                    textAlign: 'center', 
                    marginBottom: '14px',  
                    fontSize: fontSize,  
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <button 
                    onClick={handleFirstPage} 
                    disabled={currentPage === 1} 
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                    }}
                >
                    <img src={doubleChevron} alt="Primera página" style={{ width: '16px', height: '16px', transform: 'scaleX(-1)', filter: 'invert(100%)' }} />
                </button>
                <button 
                    onClick={handlePreviousPage} 
                    disabled={currentPage === 1} 
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                    }}
                >
                    <img src={chevron} alt="Página anterior" style={{ width: '16px', height: '16px', transform: 'scaleX(-1)', filter: 'invert(100%)' }} />
                </button>
                <span style={paginationTextStyle}>
                    {paginationText}
                </span>
                <button 
                    onClick={handleNextPage} 
                    disabled={currentPage === totalPages} 
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                    }}
                >
                    <img src={chevron} alt="Siguiente página" style={{ width: '16px', height: '16px', filter: 'invert(100%)' }} />
                </button>
                <button 
                    onClick={handleLastPage} 
                    disabled={currentPage === totalPages} 
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 'inherit',
                    }}
                >
                    <img src={doubleChevron} alt="Última página" style={{ width: '16px', height: '16px', filter: 'invert(100%)' }} />
                </button>
            </div>

            <div className="contenedor-tabla-intraday"
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    minHeight: 0
                }}>
                <div className="flex-tabla" style={{ minWidth: 'max-content' }}>
                    <div className="flex-fila header-row-dolar">
                        <div className="flex-celda">
                            <StaticSingleCell content={"FECHA"} isTitle={true}/>
                        </div>
                        <div className="flex-celda">
                            <StaticSingleCell content={"MAX"} isTitle={true}/>
                        </div>
                        <div className="flex-celda">
                            <StaticSingleCell content={"MIN"} isTitle={true}/>
                        </div>
                        <div className="flex-celda">
                            <StaticSingleCell content={"CIERRE"} isTitle={true}/>
                        </div>
                        <div className="flex-celda">
                            <StaticSingleCell content={"VOLUMEN"} isTitle={true}/>    
                        </div>

                    </div>
                    {currentRecords.map((_, index) => (
                        <IntradayRecordsRow 
                            key={index} 
                            rowId={index}
                            data={{
                                fecha: formatDateResponsive(
                                    data.dates[indexOfFirstRecord + index], 
                                    screenWidth
                                ),
                                max: formatAccordingToType(con.MONEY, data.high[indexOfFirstRecord + index], { allowDecimals: true }), 
                                min: formatAccordingToType(con.MONEY, data.low[indexOfFirstRecord + index], { allowDecimals: true }), 
                                cierre: formatAccordingToType(con.MONEY, data.close[indexOfFirstRecord + index], { allowDecimals: true }),
                                volume: formatAccordingToType(con.MONEY, data.volume[indexOfFirstRecord + index], { allowDecimals: true })
                            }}
                            padding={paddingCell} 
                            minWidthDate={minWidthDate} 
                            minWidthOther={minWidthOther}
                            screenWidth={screenWidth} 
                        />                       
                    ))}
                </div>
            </div>
        </div>
    );
}

IntradayRecordsTable.defaultProps = {
    fixedSize: null,
};

export default IntradayRecordsTable;